import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  accordion: {
    background: 'transparent',
  },
  accordionSummaryTitle: {
    fontWeight: 500,
  },
  accordionDetails: {
    '&>div>p ': {
      marginBottom: 0,
    },
  },
}))
